import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircleIcon } from 'lucide-react';
export function Problem() {
  return <section className="py-20 bg-white border-y border-parchment-dark" data-id="element-204">
      <div className="container mx-auto px-4" data-id="element-205">
        <div className="max-w-4xl mx-auto" data-id="element-206">
          <FadeIn data-id="element-207">
            <div className="flex items-center gap-4 mb-8 justify-center md:justify-start" data-id="element-208">
              <div className="w-12 h-[1px] bg-red-800/30 hidden md:block" data-id="element-209"></div>
              <h2 className="text-3xl md:text-4xl font-bold text-ink text-center md:text-left flex items-center gap-3" data-id="element-210">
                <AlertCircleIcon className="w-8 h-8 text-red-800/60" data-id="element-211" />
                El dolor que nadie menciona
              </h2>
              <div className="w-12 h-[1px] bg-red-800/30 hidden md:block" data-id="element-212"></div>
            </div>
          </FadeIn>

          <div className="bg-parchment/50 p-8 md:p-12 rounded-2xl border border-parchment-dark shadow-sm" data-id="element-213">
            <FadeIn delay={0.1} data-id="element-214">
              <p className="text-lg md:text-xl text-charcoal mb-6 leading-relaxed" data-id="element-215">
                El dolor real no es solo no tener dinero; es la{' '}
                <strong className="font-semibold text-ink" data-id="element-216">
                  ansiedad de no saber cómo vas a pagar el alquiler
                </strong>{' '}
                el próximo mes. Es el nudo en el estómago cada vez que pasas tu
                tarjeta y rezas para que no sea rechazada.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-217">
              <p className="text-lg md:text-xl text-charcoal mb-6 leading-relaxed" data-id="element-218">
                Has intentado "pensar positivo" y has repetido versículos de
                memoria, pero sin una estructura, tus palabras se las lleva el
                viento.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-219">
              <p className="text-lg md:text-xl text-charcoal leading-relaxed font-serif italic text-center mt-8 text-red-900/80 border-l-4 border-red-800/30 pl-6 py-2" data-id="element-220">
                "Estás operando con una mentalidad de carencia que bloquea la
                misma bendición que estás pidiendo a gritos."
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}